// quiz-config.js — Find Your Daily Ritual quiz configuration
// Source of truth for quiz questions and scent families.
// Question/answer copy: brainstorm/quiz-questions-draft.md (v6).
// Schema and conventions: docs/superpowers/specs/2026-05-28-find-your-ritual-quiz-design.md.
//
// Convention reminder: Q1's question id is "top_concern" (NOT "concern").
// All scoring keys throughout the project use "top_concern.X" style.

// ---------------------------------------------------------------------------
// HH_SCENT_FAMILIES — kept for reference (formerly used by Q8 scent question)
// ---------------------------------------------------------------------------
const HH_SCENT_FAMILIES = [
  { id: "bright_citrus",       label: "Bright citrus",       examples: "lemon, bergamot, grapefruit" },
  { id: "sweet_citrus",        label: "Sweet citrus & fruit", examples: "orange, mandarin, blackcurrant" },
  { id: "tropical",            label: "Tropical & sun-kissed", examples: "coconut, lime, frangipani, monoi" },
  { id: "white_florals",       label: "White florals",        examples: "jasmine, gardenia, neroli, tuberose" },
  { id: "powdery_florals",     label: "Powdery florals",      examples: "rose, violet, iris" },
  { id: "soft_herbs",          label: "Soft herbs",           examples: "lavender, sage, basil" },
  { id: "green_grassy",        label: "Green & grassy",       examples: "violet leaf, fig leaf, galbanum" },
  { id: "cool_woods",          label: "Cool woods",           examples: "cedar, sandalwood, vetiver" },
  { id: "warm_woods",          label: "Warm woods",           examples: "amyris, guaiac, oud" },
  { id: "resins_incense",      label: "Resins & incense",     examples: "frankincense, myrrh, benzoin" },
  { id: "sweet_spice",         label: "Sweet spice",          examples: "cinnamon, clove, cardamom" },
  { id: "gourmand",            label: "Gourmand",             examples: "vanilla, tonka, honey, almond" },
];

// ---------------------------------------------------------------------------
// HH_QUIZ_QUESTIONS — product-matching questions (merged into unified quiz)
// ---------------------------------------------------------------------------
const HH_QUIZ_QUESTIONS = [
  // -------- Q1 --------
  {
    id: "top_concern",
    questionNumber: 1,
    type: "multi",
    promptText: "What are your skincare concerns?",
    layout: "chip",
    answers: [
      { id: "dryness",      label: "Dryness or dehydration" },
      { id: "aging",        label: "Aging — fine lines, loss of firmness" },
      { id: "sensitivity",  label: "Sensitivity or redness" },
      { id: "acne",         label: "Acne or breakouts" },
      { id: "eczema",       label: "Eczema or dermatitis patches" },
      { id: "dark_spots",   label: "Dark spots or uneven tone" },
      { id: "scars",        label: "Scars or marks" },
      { id: "lips_hands",   label: "Chapped lips, dry hands, cuticle care" },
      { id: "weathered",    label: "Weathered or rough skin" },
      { id: "none",         label: "I have none of these concerns", isNoneOption: true, isExclusive: true },
    ],
  },

  // -------- Q3 --------
  {
    id: "skin_type",
    questionNumber: 3,
    type: "single",
    promptText: "How does your skin feel through the day if you haven't applied any products?",
    layout: "card",
    answers: [
      { id: "dry",         label: "Tight, dry, or uncomfortable by mid-morning. I need moisture to feel comfortable." },
      { id: "combination", label: "Comfortable in the morning, but my t-zone or forehead gets shiny by afternoon." },
      { id: "oily",        label: "Shiny or oily across most of my face by midday." },
      { id: "balanced",    label: "Balanced — comfortable throughout the day with no particular issues." },
    ],
  },

  // -------- Q4 --------
  {
    id: "hair_goal",
    questionNumber: 4,
    type: "single",
    promptText: "What does your hair need most?",
    layout: "card",
    answers: [
      { id: "frizz",    label: "Smoothing and frizz control" },
      { id: "thinning", label: "Fullness — my hair is thinning or shedding" },
      { id: "growth",   label: "Length — I'm growing it out" },
      { id: "damage",   label: "Repair — it's color-treated, heat-styled, or breaking" },
      { id: "maintain", label: "General conditioning and shine" },
    ],
  },


];

// ---------------------------------------------------------------------------
// Window assignment
// ---------------------------------------------------------------------------
window.HH_QUIZ_QUESTIONS = HH_QUIZ_QUESTIONS;
window.HH_SCENT_FAMILIES = HH_SCENT_FAMILIES;
